import { NgModule, inject, provideAppInitializer } from '@angular/core';
import * as FullStory from '@fullstory/browser';
import { NGXS_PLUGINS } from '@ngxs/store';
import { environment } from '~env';
import { MonitoringEffects } from './monitoring.effects';
import { MonitoringMetaReducer } from './monitoring.meta-reducer';

export function noop(effects?: MonitoringEffects) {
  return () => {
    console.debug('noop MonitoringEffects');
  };
}
@NgModule({
  providers: [
    MonitoringEffects,
    provideAppInitializer(() => {
        const initializerFn = (noop)(inject(MonitoringEffects));
        return initializerFn();
      }),
    MonitoringMetaReducer,
    {
      provide: NGXS_PLUGINS,
      useClass: MonitoringMetaReducer,
      multi: true,
    },
  ],
})
export class MonitoringModule {
  constructor() {
    FullStory.init({ orgId: environment.monitoring.fullStoryOrgId });
  }
}
